



























































































import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import PermitApplicationDocument from '@/Permit/PermitApplicationDocument';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import BuildEntityListComponentMixin from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import fileSaver from 'file-saver';
import VatsAPI from '@/Shared/VatsAPI';
import constants from '@/constants';

const component = mixins(LocationBasedMixin, BuildEntityListComponentMixin<PermitApplicationDocument>()).extend({
    data() {
        return {
            i18nPrefix: 'admin.permitManagement.applicationDocuments',
            file: (undefined as unknown) as File,
        };
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/permits/documents`;
        },
        filePlaceHolder(): string {
            return this.editItem?.fileName || this.$t(this.i18nPrefix + '.downloadMessage').toString();
        }
    },
    methods: {
        async upload(entity: PermitApplicationDocument) {
            if (this.file != null) {
                const formData = new FormData();
                formData.append('file', this.file, this.file.name);
                if (this.editItem?.recID != null) {
                    await VatsAPI.delete(`${this.location}/permits/deleteDocument`, { data: this.editItem });
                }
                const url = `/${this.location}/permits/import`;
                const result = await VatsAPI.post<PermitApplicationDocument>(url, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                entity.fileName = this.file.name;
                entity.imageServerID = result.data.toString();
            }
            delete entity.recID;
            this.saveEntity(entity);
            this.loadEntities();
        },
        async download(entity: PermitApplicationDocument) {
            Vue.set(this.loadingEntity, entity.recID, true);
            try {
                const response = (await VatsAPI.get<Blob>(`${this.location}/permits/documentAttachment`,
                    {
                        params: {
                            recId: entity.recID
                        },
                    headers: {
                        accept: constants.OctetMimeType
                    },
                    responseType: 'blob'
                }));
                fileSaver.saveAs(response.data, entity.fileName);
            }
            finally {
                Vue.set(this.loadingEntity, entity.recID, false);
            }
        },
    }
});

export default component;
